import React from "react";

import { Link } from "react-router-dom";

const columns = (updateRole = false) => {
  let returnArray = [
    {
      text: "Name",
      dataField: "name",
    },

    {
      text: "Hide Fillet Sizes",
      dataField: "hide_fillet_sizes",
      formatter: (cell) => (cell ? "Yes" : "No"),
    },

    {
      text: "Default",
      dataField: "default",
      formatter: (cell) => (cell ? "Yes" : "No"),
    },
  ];

  if (updateRole) {
    returnArray.push({
      text: "Edit",
      dataField: "edit",
      csvExport: false,
      formatter: (cell, row) => <Link to={`/project/qa/welding_inspections/welding_types/${row.id}/edit`}>Edit</Link>,
    });
  }

  return returnArray;
};

export default columns;
